import React from 'react';
import { cn } from '../../lib/utils';

const Card = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('rounded-card border border-surface-muted bg-surface-card text-brand-ice shadow-card', className)}
    {...props}
  />
));
Card.displayName = 'Card';

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col space-y-1.5 p-6', className)} {...props} />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef(({ className, children, 'aria-label': ariaLabel, ...props }, ref) => {
  const hasContent = React.Children.count(children) > 0;
  if (!hasContent) {
    // Evita un heading vuoto (fix ESLint `jsx-a11y/heading-has-content` in CI=true)
    return (
      <div
        ref={ref}
        className={cn('font-display text-xl font-semibold leading-none tracking-wide text-brand-ice', className)}
        aria-label={ariaLabel || 'Titolo'}
        {...props}
      />
    );
  }

  return (
    <h3
      ref={ref}
      className={cn('font-display text-xl font-semibold leading-none tracking-wide text-brand-ice', className)}
      {...props}
    >
      {children}
    </h3>
  );
});
CardTitle.displayName = 'CardTitle';

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('p-6 pt-0', className)} {...props} />
));
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex items-center p-6 pt-0', className)} {...props} />
));
CardFooter.displayName = 'CardFooter';

export { Card, CardHeader, CardTitle, CardContent, CardFooter };
